import {
    ACTION_NFT_MINT_PANEL_STEP,
    ACTION_SET_LIQUID_ID_COLLECTION_ID,
    ACTION_SET_NFT_PANEL_OPEN,
    ACTION_SET_OPENSEA_URL,
    type NftActionTypes,
    type NftState,
} from '../types/nft';

const DEFAULT: NftState = {
    liquidIdCollectionId: null,
    nftMintPanelStep: null,
    nftPanelOpen: false,
    openSeaUrl: null,
};

export function nft(state: NftState = DEFAULT, action: NftActionTypes): NftState {
    switch (action.type) {
        case ACTION_SET_LIQUID_ID_COLLECTION_ID:
            return { ...state, liquidIdCollectionId: action.liquidIdCollectionId };
        case ACTION_NFT_MINT_PANEL_STEP:
            return { ...state, nftMintPanelStep: action.nftMintPanelStep };
        case ACTION_SET_NFT_PANEL_OPEN:
            return { ...state, nftPanelOpen: action.nftPanelOpen };
        case ACTION_SET_OPENSEA_URL:
            return { ...state, openSeaUrl: action.openSeaUrl };
        default:
            return { ...state };
    }
}
